import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../environments/environment';
import {
  MessstelleQrInfo,
  MessstelleQrStatus,
  PublicMessstelle
} from '../Models/messstelle-qr.model';


@Injectable({
  providedIn: 'root'
})
export class MessstelleQrService {

  private readonly baseUrl =
    environment.apiBaseUrl + '/messstelle-qr';


  constructor(
    private http: HttpClient
  ) { }


  // ========================================================
  // ÖFFENTLICH
  // ========================================================

  /**
   * Der Endpunkt bleibt ohne Login erreichbar.
   *
   * Ist der Benutzer aber bereits angemeldet, wird sein JWT trotzdem
   * mitgeschickt. Dadurch kann der Server zusätzlich feststellen, ob er
   * regulären Projektzugriff / Schreibrechte hat.
   */
  getPublic(
    token: string
  ): Observable<PublicMessstelle> {

    const jwt =
      localStorage.getItem('token');

    const optionen =
      jwt
        ? {
          headers: new HttpHeaders({
            Authorization: `Bearer ${jwt}`
          })
        }
        : {};

    return this.http.get<PublicMessstelle>(
      `${this.baseUrl}/public/${encodeURIComponent(token)}`,
      optionen
    );
  }


  publicBildUrl(
    token: string,
    bildId: number
  ): string {

    return (
      `${this.baseUrl}/public/`
      + `${encodeURIComponent(token)}`
      + `/bilder/${bildId}`
    );
  }


  // ========================================================
  // ADMIN / QR-POOL
  // ========================================================

  generieren(
    anzahl: number
  ): Observable<MessstelleQrInfo[]> {

    return this.http.post<MessstelleQrInfo[]>(
      `${this.baseUrl}/admin/generieren`,
      {
        anzahl
      }
    );
  }


  getAlleQrCodes():
    Observable<MessstelleQrInfo[]> {

    return this.http.get<MessstelleQrInfo[]>(
      `${this.baseUrl}/admin`
    );
  }

  getQrStatus(
    messstelleId: number
  ): Observable<MessstelleQrStatus> {

    return this.http.get<MessstelleQrStatus>(
      `${this.baseUrl}/messstellen/${messstelleId}/status`
    );
  }


  // ========================================================
  // MESSSTELLE
  // ========================================================

  getAktuellenQr(
    messstelleId: number
  ): Observable<MessstelleQrInfo> {

    return this.http.get<MessstelleQrInfo>(
      `${this.baseUrl}/messstellen/${messstelleId}`
    );
  }


  zuordnen(
    messstelleId: number,
    wert: string
  ): Observable<MessstelleQrInfo> {

    return this.http.post<MessstelleQrInfo>(
      `${this.baseUrl}/messstellen/${messstelleId}/zuordnen`,
      {
        wert
      }
    );
  }


  ersetzen(
    messstelleId: number,
    wert: string
  ): Observable<MessstelleQrInfo> {

    return this.http.post<MessstelleQrInfo>(
      `${this.baseUrl}/messstellen/${messstelleId}/ersetzen`,
      {
        wert
      }
    );
  }
}
